import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DynamicForm from '../Form';

import './index.css'

class ModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: props.showModal
        }

    }

    toggle = () => {
        this.props.toggleEntireModal &&
            this.props.toggleEntireModal(!this.state.modal)
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        const { modal } = this.state;
        return (
            <div>
                <Modal isOpen={modal} fade={false} style={{ maxWidth: '650px' }}>
                    <ModalHeader className={`${this.props.headerColor } justify-content-center `}>{this.props.heading}
                        {
                            this.props.headingIcon &&
                            <i style={{ position: 'absolute', right: '10px', top: '0', alignItems: 'center', height: '100%', display: 'inline-flex', }} className={this.props.headingIcon} ></i>
                        }
                    </ModalHeader>
                    <ModalBody >
                        {
                            this.props.htmlText &&
                            <div>
                                {require('html-react-parser')(
                                    this.props.htmlText
                                )}
                            </div>
                        }
                        {
                            this.props.htmlTag &&
                            this.props.htmlTag
                        }
                        {
                            this.props.formData &&
                            <DynamicForm
                                hideClose={this.props.hideClose}
                                formName={this.props.modalName}
                                data={this.props.formData}
                                action={this.props.action}
                                toggle={this.toggle.bind(this)}
                                reducer="updateSeller"
                                id={this.props.id}
                                isReset={this.props.isReset}
                                selects={this.props.selects}
                                selectKey={this.props.selectKey}
                                footerFormSubmitButton={this.props.footerFormSubmitButton}
                                noClose={this.props.noClose !== undefined ? this.props.noClose : false}
                            />
                        }
                        {
                            this.props.footerNonSubmitButton &&
                            <ModalFooter style={{ margin: "auto", padding: '0px' }} >
                                {
                                    this.props.footerNonSubmitButton.map(
                                        (buttonData, i) => {
                                            return (
                                                < button key={i} onClick={() => this.props.responseHandler(buttonData.buttonName)} className=" btn btn-sm text-white b-0 " style={{ backgroundColor: "rgb(55, 65, 75)" }}><span className="">{buttonData.buttonName}</span></button>
                                            )
                                        }
                                    )
                                }
                                {/* {
                                    < button onClick={this.props.responseHandler} className="btn text-white b-0 " style={{ backgroundColor: "rgb(55, 65, 75)" }}><span className="">{this.props.footerNonSubmitButton[0]}</span></button>
                                }

                                <button className="btn text-white b-0 " style={{ backgroundColor: "rgb(55, 65, 75)" }} onClick={this.toggle.bind(this)}><span className="">{this.props.footerNonSubmitButton[1]}</span></button> */}
                            </ModalFooter>
                        }

                    </ModalBody>

                </Modal>
            </div >
        );
    }
}

// Navbar.propTypes = {
//     navItems: PropTypes.array
//   };

export default ModalComponent


// WEBPACK FOOTER //
// ./src/_components/common/Modal/index.js